var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89665 5.99996L0.202387 10.7949C-0.06752 11.0706 -0.0674045 11.5175 0.202387 11.7932C0.472293 12.0689 0.909843 12.0689 1.17974 11.7932L5.874 6.99827L10.5683 11.7932C10.8382 12.0689 11.2757 12.0689 11.5456 11.7932C11.8155 11.5175 11.8155 11.0706 11.5456 10.7949L6.85136 5.99996L11.5456 1.205C11.8154 0.929307 11.8154 0.48237 11.5456 0.206684C11.2757 -0.0688944 10.8382 -0.0688944 10.5683 0.206684L5.874 5.00164L1.17974 0.206684C0.909834 -0.0688944 0.472285 -0.0688944 0.202387 0.206684C-0.0674045 0.48238 -0.0674045 0.929316 0.202387 1.205L4.89665 5.99996Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d25635eb0f1b266fcd720f8d32b87f76.svg";
export { ForwardRef as ReactComponent };